import axios from '@/lib/axios';
import * as _m from '@/models';

/**
 * 000. CSRFトークン
 */
export const csrfToken = (): Promise<any> => {
  return axios.get(`csrf_token`, {});
};

/**
 * 010. 特集一覧
 */
export const features = (): Promise<_m.Feature[]> => {
  return axios.get(`/features`);
};

/**
 * 020. チャネル一覧
 */
export const channels = (): Promise<_m.ChannelOutline[]> => {
  return axios.get(`/channels`);
};

/**
 * 030. チャネル詳細
 */
export const channel = (cid: string): Promise<_m.Channel> => {
  return axios.get(`/channels/${cid}`);
};

/**
 * 040. チャネル投稿一覧
 */
type ChannelPostsParams = {
  cid: string;
  page: number;
  per: number;
  sort: string;
};
export type ChannelPostsResponse = {
  total_count: number;
  page: number;
  per: number;
  has_next: boolean;
  channel_posts: _m.ChannelPost[];
};
export const channelPosts = (params: ChannelPostsParams): Promise<ChannelPostsResponse> => {
  return axios.get(`/channels/${params.cid}/channel_posts`, { params: params });
};

/**
 * 050. チャネル投稿詳細
 */
export const channelPost = (cid: string, channel_post_id: number | string): Promise<_m.ChannelPost> => {
  return axios.get(`/channels/${cid}/channel_posts/${channel_post_id}`);
};

/**
 * 060. 動画再生登録
 */
type MoviePlaysParams = {
  cid: string;
  id: number;
};
export const moviePlays = ({ cid, id }: MoviePlaysParams): Promise<any> => {
  return axios.post(`/channels/${cid}/channel_posts/${id}/movie_plays`);
};

/**
 * 070. 投稿一覧
 */
type SearchChannelPostsParams = {
  keyword: string;
  page: number;
  per: number;
};
export type SearchChannelPostsResponse = {
  total_count: number;
  page: number;
  per: number;
  has_next: boolean;
  channel_posts: _m.ChannelPost[];
};
export const searchChannelPosts = (params: SearchChannelPostsParams): Promise<SearchChannelPostsResponse> => {
  return axios.get(`/channel_posts`, { params: params });
};

/**
 * 080. チャネル最新投稿詳細
 */
export const channelNewestPost = (cid: string): Promise<_m.ChannelPost> => {
  return axios.get(`/channels/${cid}/channel_posts/newest`);
};

/**
 * 090. チャネル投稿コメント一覧
 */
export const channelPostComments = (cid: string, channel_post_id: number): Promise<_m.Comment[]> => {
  return axios.get(`/channels/${cid}/channel_posts/${channel_post_id}/channel_post_comments`);
};

/**
 * 100. チャネル投稿コメント登録
 */
type CreateChannelPostCommentParams = {
  cid: string;
  id: number;
  content: string;
  fingerprint?: string;
  device_id?: string;
};
export const createChannelPostComment = ({
  cid,
  id,
  content,
  fingerprint,
  device_id,
}: CreateChannelPostCommentParams): Promise<_m.Comment> => {
  return axios.post(`/channels/${cid}/channel_posts/${id}/channel_post_comments`, { content, fingerprint, device_id });
};

/**
 * 110. プレイリスト一覧
 */
export const playlists = (): Promise<_m.Playlist[]> => {
  return axios.get(`/playlists`);
};

/**
 * 120. ランキング一覧
 */
export const rankings = (): Promise<_m.Ranking[]> => {
  return axios.get(`/rankings`);
};

/**
 * 130. 広告バナー一覧
 */
export const ad_banners = (): Promise<_m.AdBanner[]> => {
  return axios.get(`/ad_banners`);
};

/**
 * HeavenTVバナー埋め込み用
 */
export const ranking_ad = (): Promise<_m.RankingAd> => {
  return axios.get(`/rankings/for_ad`);
};
